var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3913 30.7652C14.1246 31.5252 12.5421 31.5252 11.2753 30.7652L1.94202 25.1652C0.737197 24.4423 0 23.1403 0 21.7352V10.2648C0 8.85971 0.737195 7.55768 1.94202 6.83479L11.2753 1.23479C12.5421 0.474752 14.1246 0.474752 15.3913 1.23479L24.7246 6.83479C25.9295 7.55768 26.6667 8.85971 26.6667 10.2648V21.7352C26.6667 23.1403 25.9295 24.4423 24.7246 25.1652L15.3913 30.7652Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1419 14.3239L25 12.749L27.8581 14.3239C28.1811 14.5019 28.6324 14.6089 29.0014 14.3277C29.3571 14.0566 29.3962 13.602 29.3367 13.2388L28.7856 9.87104L31.1162 7.48997C31.378 7.22249 31.5923 6.83039 31.4614 6.4086C31.3279 5.97829 30.9206 5.78579 30.55 5.72933L27.3483 5.2417L25.9121 2.19163C25.757 1.86232 25.4614 1.49983 24.9997 1.5C24.5383 1.50017 24.2428 1.8626 24.0879 2.19163L22.6517 5.2417L19.45 5.72933C19.079 5.78584 18.6717 5.97853 18.5384 6.4091C18.4079 6.83081 18.6223 7.22273 18.8838 7.48997L21.2143 9.87104L20.6633 13.2388C20.6038 13.6023 20.6429 14.0571 20.999 14.3281C21.3681 14.6089 21.8192 14.5018 22.1419 14.3239Z",
    fill: "#59BF8F",
    stroke: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.039b9ab9bd80c33185441646a5e2b40a.svg";
export { ForwardRef as ReactComponent };